/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'qr-bg': {
    width: 226,
    height: 254,
    viewBox: '0 0 226 254',
    data: '<path pid="0" d="M199.571 0H26.316C11.859 0 0 11.86 0 26.316v336.232c0 14.457 11.86 26.316 26.316 26.316h173.368c14.457 0 26.316-11.746 26.316-26.316V26.316C225.887 11.859 214.028 0 199.571 0zM85.159 18.974h55.456a3.157 3.157 0 013.162 3.163 3.157 3.157 0 01-3.162 3.162H85.159a3.157 3.157 0 01-3.162-3.162 3.157 3.157 0 013.162-3.163zm27.785 356.789c-7.229 0-13.102-5.873-13.102-13.102 0-7.228 5.873-13.101 13.102-13.101 7.228 0 13.101 5.873 13.101 13.101 0 7.229-5.873 13.102-13.101 13.102zm94.646-35.577H18.297V41.676H207.59v298.51z" _fill="#fff"/>'
  }
})
